import { useSearchWorkOrderAttachments } from "@/shared/work-orders-modals/components/hooks/useSearchWOAttachaments";
import { CloseWorkOrderModalWithAttachments } from "@/shared/work-orders-modals/components/modal-close-work-order";
import { DeleteWorkOrderModal } from "@/shared/work-orders-modals/components/modal-delete-work-order";
import { EditWorkOrderModal } from "@/shared/work-orders-modals/components/modal-edit-work-order";
import { ViewerAttachmentsLinked } from "@/shared/work-orders-modals/components/viewer-attachments/viewer-attachments-linked-to-wo";
import {
	type ResourceType,
	TableWorkOrdesResoures,
} from "@/shared/work-orders-modals/components/work-order-resources/table-work-ordes-resoures";
import { INITIAL_VALUES_MODAL } from "@/shared/work-orders-modals/models/ModalInitialValue";
import type { ModalWorkOrder } from "@/shared/work-orders-modals/models/ModalWorkOrder";
import {
	AssetTreePicker,
	ErrorModal,
	getMomentTz,
	useToken,
	useUserContext,
} from "@dexteel/mesf-core";
import { Button, IconButton, Paper, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import AddBoxIcon from "@mui/icons-material/AddBox";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { globalDefaultColDef } from "@setup/ag-grid/mesf-theme";
import type {
	ColDef,
	DefaultMenuItem,
	EditableCallbackParams,
	GetContextMenuItemsParams,
	GetRowIdFunc,
	GetRowIdParams,
	GridApi,
	GridReadyEvent,
	ICellRendererParams,
	MenuItemDef,
	RowDragEndEvent,
	RowDragEnterEvent,
	RowDragLeaveEvent,
	RowDropZoneParams,
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { isNumber } from "lodash-es";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import CustomLoadingOverlay from "../../../components/loaders/LazyLoading/LazyLoading";
import { AssetNameColumnColumn } from "../components/assetName-column";
import { useTaskListContext } from "../context/taskListContext";
import { Filters } from "../filters";
import { useRefreshTaskList, useTaskList } from "../hooks/useTaskList";
import { useTaskListFilters } from "../hooks/useTaskListFilters";
import {
	type Task,
	UpdateTaskListPriority,
} from "../repositorie/TaskListRepositorie";

type onMenuOptionSelectedType =
	| "EDIT"
	| "EDIT-COMMENTS"
	| "SEE-COMMENTS"
	| "CLOSE-ORDER"
	| "ADD-ORDER"
	| "DELETE-ORDER";

const moment = getMomentTz();

export const TaskListbyDownHours = () => {
	const refreshTaskListRef = useRef<() => void>(() => {});
	const {
		state: {
			selectedRow,
			openWorkOrderEditModal,
			openCloseWorkOrderModal,
			openDeleteWorkOrderModal,
			openDialogLinkAttachmentToWo,
		},
		actions: {
			setSelectedRow,
			setOpenWorkOrderEditModal,
			setOpenCommentsModal,
			setOpenCloseWorkOrderModal,
			setOpenDeleteWorkOrderModal,
			setWorkOrderSelectedId,
			setWorkOrderSelectedName,
			setOpenDialogLinkAttachmentToWO,
		},
	} = useTaskListContext();
	const {
		state: { defaultAreaId },
	} = useUserContext();
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [error, setError] = useState<string>("");
	const [newMode, setNewMode] = useState(false);
	const [searchParams, setSearchParams] = useSearchParams();
	const navigate = useNavigate();
	const { getUserName } = useToken();

	const gridRef1 = useRef<AgGridReact>(null);
	const gridRef2 = useRef<AgGridReact>(null);
	const gridStyle = useMemo(
		() => ({ height: "90%", width: "100%", paddingTop: 20 }),
		[],
	);

	const [areaApi, setAreaApi] = useState<{ [key: number]: GridApi } | null>(
		null,
	);
	const [attachmentsList, setAttachmentsList] = useState([]);
	const [updateAttachmentsList, setUpdateAttachmentsList] = useState(true);
	const [insertTaskError, setInsertTaskError] = useState<string>("");
	const [updatePriorityError, setUpdatePriorityError] = useState<string>("");
	const searchWorkOrderAttachments = useSearchWorkOrderAttachments({
		WorkOrderId: selectedRow?.WorkOrderId,
		setAttachmentsList,
		setIsLoading,
		setError,
	});

	const filters = useTaskListFilters();
	const {
		data: { allRows, areasNumber },
		isLoading: isTaskListLoading,
		error: taskListQueryError,
	} = useTaskList(filters);
	const refreshTaskList = useRefreshTaskList();
	const [dismissedTaskListError, setDismissedTaskListError] =
		useState<Error | null>(null);
	const taskListError =
		taskListQueryError && taskListQueryError !== dismissedTaskListError
			? taskListQueryError.message
			: "";

	refreshTaskListRef.current = refreshTaskList;

	const [openWorkOrderResources, setOpenWorkOrderResources] = useState(false);
	const [selectedResource, setSelectedResource] = useState<ResourceType | null>(
		null,
	);

	const openResourceModal = useCallback(
		(resource: ResourceType, rowData: any) => {
			if (!rowData) return;

			setSelectedRow(rowData);
			setSelectedResource(resource);
			setOpenWorkOrderResources(true);
		},
		[setSelectedRow],
	);

	const onActionsClick = (
		e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
		params: EditableCallbackParams,
	) => {
		(params.api as any).showContextMenu({
			column: params.column,
			rowNode: params.node,
			undefined,
			mouseEvent: e.nativeEvent,
		});
	};

	const loadingOverlayComponent = useMemo<any>(() => {
		return CustomLoadingOverlay;
	}, []);

	const addGridDropZone = useCallback(
		(api: GridApi | null, targets: (GridApi | null)[]) => {
			if (!api) return;

			targets.forEach((target) => {
				if (!target) return;

				const dropZoneArea1: RowDropZoneParams = {
					getContainer: () => document.getElementById("drop-zone-1")!,
					onDragEnter: (params: RowDragEnterEvent) => {
						const overGridApi = params.api;
						if (overGridApi && overGridApi !== api) {
							overGridApi.setGridOption("rowStyle", {
								background: "lightblue",
							});
						}
					},
					onDragLeave: (params: RowDragLeaveEvent) => {
						const overGridApi = params.api;
						if (overGridApi && overGridApi !== api) {
							overGridApi.setGridOption("rowStyle", {
								background: "lightblue",
							});
						}
					},

					onDragStop: async (params) => {
						if (!params?.api || !target) return;

						try {
							const draggingNodes = params.nodes;
							if (!draggingNodes || draggingNodes.length === 0) {
								params.api.hideOverlay();
								target.hideOverlay();
								return;
							}

							const draggedNodeData = draggingNodes[0]?.data;
							if (!draggedNodeData?.WorkOrderId) {
								params.api.hideOverlay();
								target.hideOverlay();
								return;
							}

							const dragItemId = draggedNodeData.WorkOrderId;

							let workOrderIdBelow = null;
							let targetIsDownHours = false;

							const overNode = params.overNode;

							if (target === gridRef1.current?.api) {
								targetIsDownHours = true;
							} else if (target === gridRef2.current?.api) {
								targetIsDownHours = false;
							}

							if (overNode) {
								if (overNode.data?.WorkOrderId !== dragItemId) {
									workOrderIdBelow = overNode.data.WorkOrderId;
								} else if (
									params.overIndex !== undefined &&
									params.overIndex > 0
								) {
									const rowBeforeDrop = target.getDisplayedRowAtIndex(
										params.overIndex - 1,
									);
									if (
										rowBeforeDrop &&
										rowBeforeDrop.data?.WorkOrderId !== dragItemId
									) {
										workOrderIdBelow = rowBeforeDrop.data.WorkOrderId;
									}
								}
							} else if (target.getDisplayedRowCount() > 0) {
								const lastRowNode = target.getDisplayedRowAtIndex(
									target.getDisplayedRowCount() - 1,
								);
								if (
									lastRowNode &&
									lastRowNode.data?.WorkOrderId !== dragItemId
								) {
									workOrderIdBelow = lastRowNode.data.WorkOrderId;
								}
							}

							const res = await UpdateTaskListPriority(
								dragItemId,
								workOrderIdBelow,
								targetIsDownHours,
							);

							if (res?.ok) {
								refreshTaskListRef.current();
							} else {
								setUpdatePriorityError(
									res?.message || "Error updating priority",
								);
							}
						} finally {
							params.api.hideOverlay();
							target.hideOverlay();
							if (target) {
								(target as any).setGridOption("rowStyle", undefined);
							}
						}
					},
				};

				const dropZoneArea2: RowDropZoneParams = {
					getContainer: () => document.getElementById("drop-zone-2")!,
					onDragEnter: (params: RowDragEnterEvent) => {
						const overGridApi = params.api;

						if (overGridApi && overGridApi !== api) {
							overGridApi.setGridOption("rowStyle", {
								background: "lightblue",
							});
						}
					},
					onDragLeave: (params: RowDragLeaveEvent) => {
						const overGridApi = params.api;
						if (overGridApi && overGridApi !== api) {
							overGridApi.setGridOption("rowStyle", {
								background: "lightblue",
							});
						}
					},

					onDragStop: async (params) => {
						if (!params?.api || !target) return;

						try {
							const draggingNodes = params.nodes;
							if (!draggingNodes || draggingNodes.length === 0) {
								params.api.hideOverlay();
								target.hideOverlay();
								return;
							}

							const draggedNodeData = draggingNodes[0]?.data;
							if (!draggedNodeData?.WorkOrderId) {
								params.api.hideOverlay();
								target.hideOverlay();
								return;
							}

							const dragItemId = draggedNodeData.WorkOrderId;

							let workOrderIdBelow = null;
							let targetIsDownHours = false;

							const overNode = params.overNode;

							if (target === gridRef1.current?.api) {
								targetIsDownHours = true;
							} else if (target === gridRef2.current?.api) {
								targetIsDownHours = false;
							}

							if (overNode) {
								if (overNode.data?.WorkOrderId !== dragItemId) {
									workOrderIdBelow = overNode.data.WorkOrderId;
								} else if (
									params.overIndex !== undefined &&
									params.overIndex > 0
								) {
									const rowBeforeDrop = target.getDisplayedRowAtIndex(
										params.overIndex - 1,
									);
									if (
										rowBeforeDrop &&
										rowBeforeDrop.data?.WorkOrderId !== dragItemId
									) {
										workOrderIdBelow = rowBeforeDrop.data.WorkOrderId;
									}
								}
							} else if (target.getDisplayedRowCount() > 0) {
								const lastRowNode = target.getDisplayedRowAtIndex(
									target.getDisplayedRowCount() - 1,
								);
								if (
									lastRowNode &&
									lastRowNode.data?.WorkOrderId !== dragItemId
								) {
									workOrderIdBelow = lastRowNode.data.WorkOrderId;
								}
							}

							const res = await UpdateTaskListPriority(
								dragItemId,
								workOrderIdBelow,
								targetIsDownHours,
							);

							if (res?.ok) {
								refreshTaskListRef.current();
							} else {
								setUpdatePriorityError(
									res?.message || "Error updating priority",
								);
							}
						} finally {
							params.api.hideOverlay();
							target.hideOverlay();
							if (target) {
								(target as any).setGridOption("rowStyle", undefined);
							}
						}
					},
				};

				api?.addRowDropZone?.(dropZoneArea1);
				api?.addRowDropZone?.(dropZoneArea2);
			});
		},
		[],
	);

	const { routineRows, downHourRows } = useMemo(
		() =>
			(allRows || []).reduce(
				(carry, current) => {
					if (!current) return carry;

					if (isNumber(current.DownHours) && current.DownHours > 0) {
						carry.downHourRows.push(current);
					} else {
						carry.routineRows.push(current);
					}
					return carry;
				},
				{
					routineRows: [] as Task[],
					downHourRows: [] as Task[],
				},
			),
		[allRows],
	);

	const onRowDragEnd = async (params: RowDragEndEvent) => {
		if (!params?.node?.data?.WorkOrderId || !params?.api) return;

		const draggedNodeData = params.node.data;
		const draggedNodeId = draggedNodeData.WorkOrderId;

		let workOrderIdBelow = null;
		if (params.overIndex !== undefined && params.overIndex !== null) {
			const overNode = params.api.getDisplayedRowAtIndex(params.overIndex);
			if (overNode && overNode.data?.WorkOrderId !== draggedNodeId) {
				workOrderIdBelow = overNode.data.WorkOrderId;
			} else if (params.overIndex > 0) {
				const rowBeforeDrop = params.api.getDisplayedRowAtIndex(
					params.overIndex - 1,
				);
				if (
					rowBeforeDrop &&
					rowBeforeDrop.data?.WorkOrderId !== draggedNodeId
				) {
					workOrderIdBelow = rowBeforeDrop.data.WorkOrderId;
				}
			}
		}
		try {
			const isCurrentGridDownHours =
				isNumber(draggedNodeData.DownHours) && draggedNodeData.DownHours > 0;

			const res = await UpdateTaskListPriority(
				draggedNodeId,
				workOrderIdBelow,
				isCurrentGridDownHours,
			);
			if (res?.ok) {
				refreshTaskList();
			} else {
				setUpdatePriorityError(res?.message || "Error updating priority");
			}
		} finally {
			params.api?.hideOverlay?.();
		}
	};

	const onGridReadyForArea = (area: number, params: GridReadyEvent) => {
		if (!params.api) return;

		setAreaApi((prev) => ({ ...(prev || {}), [area]: params.api }));
	};

	const renderCategoryCell = (props: ICellRendererParams) => {
		if (!props?.data) return null;

		return (
			<div
				style={{
					height: 32,
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<div
					style={{
						height: 26,
						width: 26,
						borderRadius: 4,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						background: props.data?.CraftColor || "#FFFFFF",
					}}
				>
					<div style={{ color: "#FFF", fontWeight: 600 }}>
						<div>{props.data?.CraftName?.charAt?.(0) || ""}</div>
					</div>
				</div>
			</div>
		);
	};

	const renderTypeCell = (props: ICellRendererParams) => {
		if (!props.data) return null;

		return (
			<div
				style={{
					height: 32,
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<div
					style={{
						height: 26,
						width: 26,
						borderRadius: 4,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						background: props.data?.TypeCode == "PM" ? "#00008B" : "#D3D3D3",
					}}
				>
					<div
						style={{
							color: props.data?.TypeCode == "PM" ? "#FFFFFF" : "#000000",
							fontWeight: 600,
						}}
					>
						<div>{props.data?.TypeCode || ""}</div>
					</div>
				</div>
			</div>
		);
	};

	const [downHourColumnDefs, setDownHourColumnDefs] = useState<ColDef[]>([
		{ field: "", headerName: "", rowDrag: true, minWidth: 20, maxWidth: 20 },
		{
			cellRenderer: AssetNameColumnColumn,
			headerName: "Asset",
			minWidth: 90,
			flex: 4,
		},
		{ field: "Title", headerName: "Title", minWidth: 90, flex: 5 },
		{
			field: "DownHours",
			headerName: "Down Hours",
			minWidth: 60,
			maxWidth: 60,
			flex: 1,
		},
		{
			field: "CraftId",
			headerName: "Craft",
			minWidth: 35,
			maxWidth: 35,
			flex: 1,
			cellRenderer: renderCategoryCell,
		},
		{
			field: "TypeCode",
			headerName: "Type",
			minWidth: 55,
			maxWidth: 55,
			flex: 1,
			cellRenderer: renderTypeCell,
		},
		{
			headerName: "",
			flex: 1,
			minWidth: 65,
			maxWidth: 65,
			cellClass: "ag-columns",
			wrapText: false,
			autoHeight: false,
			cellRenderer: (params: EditableCallbackParams) => {
				return (
					<Grid2
						container
						style={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Grid2
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
							size={{ xs: 12, md: 12 }}
						>
							<Grid2
								container
								spacing={1}
								style={{ justifyContent: "flex-end", minWidth: 30 }}
							>
								<Grid2 size={{ xs: 12, md: 12 }}>
									<Button
										fullWidth
										style={{}}
										onClick={(e) => onActionsClick(e, params)}
									>
										<FormatListBulletedSharpIcon
											style={{ height: "auto" }}
											color="action"
										/>
									</Button>
								</Grid2>
							</Grid2>
						</Grid2>
					</Grid2>
				);
			},
		},
	]);

	const [routineColumnDefs, setRoutineColumnDefs] = useState<ColDef[]>([
		{ field: "", headerName: "", rowDrag: true, minWidth: 20, maxWidth: 20 },
		{
			cellRenderer: AssetNameColumnColumn,
			headerName: "Asset",
			minWidth: 90,
			flex: 5,
		},
		{ field: "Title", headerName: "Title", minWidth: 90, flex: 5 },
		{
			field: "CraftId",
			headerName: "Craft",
			minWidth: 35,
			maxWidth: 35,
			flex: 1,
			cellRenderer: renderCategoryCell,
		},
		{
			field: "TypeCode",
			headerName: "Type",
			minWidth: 55,
			maxWidth: 55,
			flex: 1,
			cellRenderer: renderTypeCell,
		},
		{
			headerName: "",
			flex: 1,
			minWidth: 65,
			maxWidth: 65,
			cellClass: "ag-columns",
			wrapText: false,
			autoHeight: false,
			cellRenderer: (params: EditableCallbackParams) => {
				return (
					<Grid2
						container
						style={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Grid2
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
							size={{ xs: 12, md: 12 }}
						>
							<Grid2
								container
								spacing={1}
								style={{ justifyContent: "flex-end", minWidth: 30 }}
							>
								<Grid2 size={{ xs: 12, md: 12 }}>
									<Button
										fullWidth
										style={{}}
										onClick={(e) => onActionsClick(e, params)}
									>
										<FormatListBulletedSharpIcon
											style={{ height: "auto" }}
											color="action"
										/>
									</Button>
								</Grid2>
							</Grid2>
						</Grid2>
					</Grid2>
				);
			},
		},
	]);

	const onMenuOptionSelected = useCallback(
		(
			option: onMenuOptionSelectedType,
			row: ModalWorkOrder,
			areaAssetId: number | null = null,
		) => {
			if (!row) return;

			setSelectedRow(row);
			switch (option) {
				case "EDIT": {
					setOpenWorkOrderEditModal(true);
					return;
				}
				case "EDIT-COMMENTS": {
					setOpenCommentsModal(true);
					return;
				}
				case "SEE-COMMENTS": {
					setOpenCommentsModal(true);
					return;
				}
				case "CLOSE-ORDER": {
					setOpenCloseWorkOrderModal(true);
					return;
				}
				case "ADD-ORDER": {
					const targetAssetId =
						areaAssetId !== null
							? areaAssetId
							: row?.AssetId !== null
								? row.AssetId
								: defaultAreaId;
					addNewOrder(targetAssetId as number);
					return;
				}
				case "DELETE-ORDER": {
					setOpenDeleteWorkOrderModal(true);
					return;
				}
				default:
					return;
			}
		},
		[
			setSelectedRow,
			setOpenWorkOrderEditModal,
			setOpenCommentsModal,
			setOpenCloseWorkOrderModal,
			setOpenDeleteWorkOrderModal,
			defaultAreaId,
		],
	);

	const getContextMenuItems = useCallback(
		(params: GetContextMenuItemsParams): (DefaultMenuItem | MenuItemDef)[] => {
			if (!params.node?.data) return [];

			const status = params.node.data.WorkOrderStatusCode;

			if (params.node.data.WorkOrderId) {
				setWorkOrderSelectedId(params.node.data.WorkOrderId);
			}

			if (params.node.data.Title) {
				setWorkOrderSelectedName(params.node.data.Title);
			}

			const result: (DefaultMenuItem | MenuItemDef)[] = [
				{
					name: "Edit Order",
					action: () => {
						onMenuOptionSelected("EDIT", params.node?.data);
					},
					icon: '<i class="fas fa-edit"></i>',
				},
			];

			result.push({
				name: "New Order",
				action: () => {
					addNewOrder(params.node?.data?.AssetId || defaultAreaId);
				},
				icon: '<i class="fas fa-plus"></i>',
			});

			result.push(
				{
					name: "Work Order Drawings",
					action: () => openResourceModal("DRAWINGS", params.node?.data),
					icon: '<i class="far fa-file-image"></i>',
				},
				{
					name: "Work Order Attachments",
					action: () => openResourceModal("ATTACHMENTS", params.node?.data),
					icon: '<i class="fas fa-paperclip"></i>',
				},
				{
					name: "Work Order LOTO",
					action: () => openResourceModal("LOTO", params.node?.data),
					icon: '<i class="fas fa-tag"></i>',
				},
				{
					name: "Work Order Parts",
					action: () => openResourceModal("PARTS", params.node?.data),
					icon: '<i class="fas fa-tools"></i>',
				},
			);

			if (status === "O") {
				result.push({
					name: "Close Order",
					action: () => {
						onMenuOptionSelected("CLOSE-ORDER", params.node?.data);
					},
					icon: '<i class="far fa-times-circle"></i>',
				});
			}
			result.push(
				{
					name: "Delete Order",
					action: () => {
						onMenuOptionSelected("DELETE-ORDER", params.node?.data);
					},
					icon: '<i class="fas fa-trash"></i>',
				},
				"separator",
				"excelExport",
			);
			return result;
		},
		[openResourceModal, defaultAreaId],
	);

	const onDobleClicked1 = useCallback(() => {
		if (!gridRef1.current?.api) return;

		const selectedNodes = gridRef1.current.api.getSelectedNodes();
		if (selectedNodes.length > 0 && selectedNodes[0].data) {
			const nodeData = { ...selectedNodes[0].data };
			onMenuOptionSelected("EDIT", nodeData);
		}
	}, [onMenuOptionSelected]);

	const onDobleClicked2 = useCallback(() => {
		if (!gridRef2.current?.api) return;

		const selectedNodes = gridRef2.current.api.getSelectedNodes();
		if (selectedNodes.length > 0 && selectedNodes[0].data) {
			const nodeData = { ...selectedNodes[0].data };
			onMenuOptionSelected("EDIT", nodeData);
		}
	}, [onMenuOptionSelected]);

	const getRowId = useMemo<GetRowIdFunc>(() => {
		return (params: GetRowIdParams) => {
			return params.data?.WorkOrderId;
		};
	}, []);

	const resetFilter = () => {
		searchParams.delete("search");
		searchParams.delete("downHours");
		searchParams.delete("type");
		searchParams.delete("craft");
		setSearchParams(searchParams, { replace: true });
		setTimeout(() => {
			const currentPath = location.pathname;
			if (currentPath.includes("/downday")) {
				navigate(`/task-list/downday/${defaultAreaId}`, { replace: true });
			} else {
				navigate(`/task-list/area/${defaultAreaId}`, { replace: true });
			}
		}, 500);
	};

	const changeAsset = (value: number | null) => {
		if (!value && value !== 0) return;

		const currentPath = location.pathname;
		if (currentPath.includes("/downday")) {
			navigate(`/task-list/downday/${value}`, { replace: true });
		} else {
			navigate(`/task-list/area/${value}`, { replace: true });
		}
	};

	const addNewOrder = useCallback(
		async (areaAssetId: number | string) => {
			if (!areaAssetId && areaAssetId !== 0) return;

			const tempWorkOrder = {
				AssetId: typeof areaAssetId === "number" ? areaAssetId : defaultAreaId,
				DownHours: Number(filters.downHours) || 0,
				WorkOrderId: null,
				Title: "",
				CraftId: 1,
				TypeCode: "RM",
				WorkOrderStatusCode: "O",
				WorkOrderName: "",
				WorkOrderNumberOfWorkers: null,
				OpenTimestamp: moment(new Date()).format("MM/DD/YYYY HH:mm"),
				WorkOrderPlannedHours: null,
				WorkOrderOpenedBy: getUserName(),
			};

			setNewMode(true);
			setSelectedRow(tempWorkOrder);
			setOpenWorkOrderEditModal(true);
		},
		[
			filters.downHours,
			defaultAreaId,
			getUserName,
			setSelectedRow,
			setOpenWorkOrderEditModal,
		],
	);

	const updateAttachmentsListFn = useCallback(() => {
		if (selectedRow?.WorkOrderId) {
			searchWorkOrderAttachments();
		}
	}, [selectedRow, searchWorkOrderAttachments]);

	useEffect(() => {
		if (openWorkOrderEditModal && selectedRow?.WorkOrderId) {
			updateAttachmentsListFn();
		}
	}, [
		openWorkOrderEditModal,
		updateAttachmentsList,
		selectedRow,
		updateAttachmentsListFn,
	]);

	useEffect(() => {
		if (areaApi && areaApi[1] && areaApi[2]) {
			addGridDropZone(areaApi[1], [areaApi[2]]);
			addGridDropZone(areaApi[2], [areaApi[1]]);
		}
	}, [areaApi, addGridDropZone]);

	if (areasNumber > 0) {
		return (
			<>
				{openWorkOrderResources && selectedResource && selectedRow && (
					<TableWorkOrdesResoures
						show={openWorkOrderResources}
						onHide={(shouldUpdate: boolean) => {
							setOpenWorkOrderResources(false);
							setSelectedResource(null);
							if (shouldUpdate) {
								refreshTaskList();
							}
						}}
						AssetId={selectedRow?.AssetId}
						WorkOrderId={selectedRow?.WorkOrderId}
						initialResource={selectedResource}
						WorkOrderName={selectedRow?.WorkOrderName as string}
						Title={selectedRow?.Title as string}
						AssetName={selectedRow?.AssetName as string}
						TypeCode={selectedRow?.TypeCode as string}
						CraftId={selectedRow?.CraftId as number}
						OpenTimestamp={selectedRow?.OpenTimestamp}
						CloseTimestamp={selectedRow?.CloseTimestamp}
					/>
				)}
				{openDialogLinkAttachmentToWo && selectedRow?.WorkOrderId && (
					<ViewerAttachmentsLinked
						show={openDialogLinkAttachmentToWo}
						workOrderSelectedId={selectedRow.WorkOrderId}
						workOrderSelectedName={selectedRow.Title}
						onHide={(shouldUpdate: boolean) => {
							if (shouldUpdate) {
								updateAttachmentsListFn();
							}
							setSelectedRow(INITIAL_VALUES_MODAL);
							setOpenDialogLinkAttachmentToWO(false);
						}}
					/>
				)}
				<Grid2 container style={{ padding: "10px 20px" }}>
					<Grid2
						container
						size={{ xs: 12 }}
						alignItems="center"
						justifyContent="center"
						spacing={1}
					>
						<Grid2 size={{ md: 12, xs: 12 }}>
							<Typography
								variant="h5"
								style={{
									margin: "0",
									fontWeight: 600,
									userSelect: "none",
									marginLeft: 5,
								}}
							>
								DOWNDAY TASK LIST
							</Typography>
						</Grid2>

						<Grid2 size={{ xs: 12 }}>
							<Paper elevation={1} style={{ padding: 10, marginBottom: 20 }}>
								<Grid2 container spacing={2} alignItems="center">
									<Grid2 size={{ lg: 2, md: 12, xs: 12 }}>
										<AssetTreePicker
											label="Asset"
											value={filters.assetId ?? 0}
											onChange={changeAsset}
										/>
									</Grid2>
									<Filters />
								</Grid2>
							</Paper>
						</Grid2>
					</Grid2>
					<Grid2
						container
						spacing={2}
						style={{ marginTop: "5px" }}
						size={{ xs: 12 }}
					>
						<Grid2
							style={{ height: "75vh", marginBottom: "20px" }}
							size={{ md: 6, xs: 12 }}
						>
							<Paper
								elevation={2}
								style={{
									height: "75vh",
									width: "100%",
									padding: "10px 10px 0",
									borderRadius: "0.75rem",
								}}
							>
								<Grid2
									container
									style={{
										height: "100%",
										width: "100%",
										position: "relative",
									}}
									size={{ md: 12, xs: 12 }}
								>
									<Grid2 size={{ md: 12, xs: 12 }}>
										<Typography
											variant="h6"
											style={{
												margin: "0 0 -30px 5px",
												fontWeight: 600,
												userSelect: "none",
											}}
										>
											Down Time Orders
										</Typography>
										<IconButton
											onClick={() => addNewOrder(1)}
											aria-label="add"
											color="primary"
											style={{
												padding: 0,
												position: "absolute",
												top: "0px",
												right: "-5px",
											}}
										>
											<AddBoxIcon
												style={{ width: 35, height: 35, marginRight: "0" }}
											/>
										</IconButton>
									</Grid2>
									<Grid2 style={gridStyle} id={"drop-zone-1"} size={{ xs: 12 }}>
										<AgGridReact
											ref={gridRef1}
											rowSelection="single"
											onRowDoubleClicked={onDobleClicked1}
											rowData={downHourRows}
											columnDefs={downHourColumnDefs}
											defaultColDef={globalDefaultColDef}
											animateRows={true}
											getContextMenuItems={getContextMenuItems}
											rowHeight={20}
											getRowId={getRowId}
											rowDragManaged={true}
											onRowDragEnd={onRowDragEnd}
											onGridReady={(params) => onGridReadyForArea(1, params)}
											suppressMoveWhenRowDragging={true}
											loadingOverlayComponent={loadingOverlayComponent}
											loading={isTaskListLoading}
										/>
									</Grid2>
								</Grid2>
							</Paper>
						</Grid2>
						<Grid2
							style={{ height: "75vh", marginBottom: "20px" }}
							size={{ md: 6, xs: 12 }}
						>
							<Paper
								elevation={2}
								style={{
									height: "75vh",
									width: "100%",
									padding: "10px 10px 0",
									borderRadius: "0.75rem",
								}}
							>
								<Grid2
									container
									style={{
										height: "100%",
										width: "100%",
										position: "relative",
									}}
									size={{ md: 12, xs: 12 }}
								>
									<Grid2 size={{ md: 12, xs: 12 }}>
										<Typography
											variant="h6"
											style={{
												margin: "0 0 -30px 5px",
												fontWeight: 600,
												userSelect: "none",
											}}
										>
											Routine Orders
										</Typography>
										<IconButton
											onClick={() => addNewOrder(0)}
											aria-label="add"
											color="primary"
											style={{
												padding: 0,
												position: "absolute",
												top: "0px",
												right: "-5px",
											}}
										>
											<AddBoxIcon
												style={{ width: 35, height: 35, marginRight: "0" }}
											/>
										</IconButton>
									</Grid2>
									<Grid2 style={gridStyle} id={"drop-zone-2"} size={{ xs: 12 }}>
										<AgGridReact
											ref={gridRef2}
											rowSelection="single"
											onRowDoubleClicked={onDobleClicked2}
											rowData={routineRows}
											columnDefs={routineColumnDefs}
											defaultColDef={globalDefaultColDef}
											animateRows={true}
											getContextMenuItems={getContextMenuItems}
											rowHeight={20}
											getRowId={getRowId}
											rowDragManaged={true}
											onRowDragEnd={onRowDragEnd}
											onGridReady={(params) => onGridReadyForArea(2, params)}
											suppressMoveWhenRowDragging={true}
											loadingOverlayComponent={loadingOverlayComponent}
											loading={isTaskListLoading}
										/>
									</Grid2>
								</Grid2>
							</Paper>
						</Grid2>
					</Grid2>
				</Grid2>
				<CloseWorkOrderModalWithAttachments
					show={openCloseWorkOrderModal}
					data={selectedRow}
					onHide={(shouldUpdate: boolean) => {
						if (shouldUpdate) {
							refreshTaskList();
							updateAttachmentsListFn();
						}
						setOpenCloseWorkOrderModal(false);
					}}
				/>
				<DeleteWorkOrderModal
					show={openDeleteWorkOrderModal}
					data={selectedRow}
					onHide={(shouldUpdate: boolean) => {
						if (shouldUpdate) {
							refreshTaskList();
						}
						setOpenDeleteWorkOrderModal(false);
					}}
				/>
				{openWorkOrderEditModal && selectedRow && (
					<EditWorkOrderModal
						show={openWorkOrderEditModal}
						data={selectedRow}
						initialNewMode={newMode}
						onHide={(shouldUpdate: boolean) => {
							if (shouldUpdate) {
								refreshTaskList();
							}
							setNewMode(false);
							setOpenWorkOrderEditModal(false);
						}}
					/>
				)}
				<ErrorModal error={error} onHide={() => setError("")} />
				<ErrorModal
					error={taskListError}
					onHide={() => setDismissedTaskListError(taskListQueryError)}
				/>
				<ErrorModal
					error={insertTaskError}
					onHide={() => setInsertTaskError("")}
				/>
				<ErrorModal
					error={updatePriorityError}
					onHide={() => setUpdatePriorityError("")}
				/>
			</>
		);
	}
	return (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "80vh",
			}}
		>
			<div className="lds-ring">
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
	);
};
